import React, { Component } from 'react';
import styled from 'styled-components';

import { colors } from '../utils/styles';

export default class TextSection extends Component {
  constructor () {
    super();

    this.state = {
      expanded: false
    };
  }

  toggleExpanded () {
    const expanded = !this.state.expanded;

    this.setState({
      expanded
    });
  }

  render () {
    const { section, isChild, pos } = this.props;
    const { expanded } = this.state;

    const paragraphs = section.paragraphs || [];
    const children = section.children || [];
    const bullets = section.bullets || [];
    const className = section.className;

    const Paragraphs = paragraphs.map((p, i) => {
      const bullets = p.bullets || [];

      let BulletList = null;
      if (bullets.length) {
        const Bullets = bullets.map((b, j) => (
          <li key={ `text-section-${ pos }-paragraph-${ i }-li-${ j }` }>{ b }</li>
        ));
        BulletList = <ul>{ Bullets }</ul>;
      }

      return (
        <div key={ `text-section-${ pos }-paragraph-${ i }` }>
          <p>{ p.text }</p>
          { BulletList }
        </div>
      );
    });
    const Children = children.map((c, i) => {
      const cPos = `${ pos }-${ i }`;

      return (
        <TextSection
          key={ `text-section-${ cPos }` }
          section={ c }
          isChild
          pos={ cPos }
        />
      );
    });

    const sectionClassName = `${ isChild ? '_child' : '' }${
      className ? ` ${ className }` : ''
    }`;

    const TextSectionDiv = styled.div`
      & p,
      & li {
        margin: 0 0 20px 0;
        font-size: 16px;
        line-height: 22px;
      }

      & ul {
        list-style-type: disc;
        padding-left: 20px;
      }

      & .title {
        display: block;
        user-select: none;
        cursor: pointer;
        width: 100%;
        padding: 20px;
        margin: 0;
        border-radius: 2px;
        font-size: 16px;
        letter-spacing: 1.5px;
        line-height: 40px;
        font-weight: 400;

        &:hover {
          background-color: ${ colors.lightGray };
        }

        & i {
          float: right;
          line-height: 40px;
        }
      }

      & .text {
        padding: 20px 0 20px 20px;
      }

      &._child {
        & .title {
          display: inline-block;
          width: auto;
          padding: 0;
          margin: 20px 0 0 20px;
          line-height: 30px;
          border-bottom: 1px solid ${ colors.darkGray };

          &:hover {
            background: none;
            opacity: 0.7;
          }
        }
      }

      &._contact {
        ul {
          list-style-type: none;
        }

        li {
          margin-bottom: 10px;
        }
      }
    `;

    return (
      <TextSectionDiv className={ sectionClassName }>
        <h5 className='title' onClick={ this.toggleExpanded.bind(this) }>
          { section.title }
          { !isChild ? (
            <i
              className={ `fas fa-caret-${ expanded ? 'up' : 'down' }` }
              aria-hidden='true'
            />
          ) : null }
        </h5>
        { expanded ? (
          <div className='text'>
            { Paragraphs }
            { Children }
          </div>
        ) : null }
      </TextSectionDiv>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TextSection.js